module.exports = __webpack_public_path__ + "static/media/slow-logo.89e6c469.svg";